module.exports = __webpack_public_path__ + "static/media/44461501_2199885740086605_2181521427029557248_o-thumb.c230f271.jpg";